/* eslint-disable internal-rules/no-restricted-design-system-props */
/* eslint-disable internal-rules/no-restricted-design-system-imports */
import type { JSX } from 'react';

import { Text } from '@change/ds-core-ui';

import { QRCode } from './components/QRCode';
import { QRCodeDownloadLink } from './components/QRCodeDownloadLink';

type QRCodeDownloadProps = {
	value: string;
	descriptionText: string;
	downloadLinkText: string;
	downloadFilename?: string;
	onDownload?: () => Promise<void>;
};
export function QRCodeDownload({
	value,
	descriptionText,
	downloadLinkText,
	downloadFilename,
	onDownload,
}: QRCodeDownloadProps): JSX.Element {
	return (
		<div className="flex flex-col gap-4 rounded-lg border border-solid border-neutral-200 p-4">
			<div className="flex justify-center gap-2">
				<div className="h-20 min-h-20 w-20 min-w-20">
					<QRCode value={value} includeMargin={false} className="flex-shrink-0" />
				</div>
				<Text variant="body" size="medium">
					{descriptionText}
				</Text>
			</div>

			<div className="flex flex-col gap-2">
				<QRCodeDownloadLink value={value} onDownload={onDownload} filename={downloadFilename}>
					{downloadLinkText}
				</QRCodeDownloadLink>
			</div>
		</div>
	);
}
